module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#business",
      toString: function () {
        return this.url;
      }
    }